import { Button } from 'antd';
import { ScreenshotLogisticsPackage, ScreenshotModal } from './ScreenshotModal';
import { useTranslate } from '@tolgee/react';
import { useToggle } from 'ahooks';

interface SendLogisticsInfoProps {
  platform?: General.PlatformUpperCaseTunnel;
  region?: General.UpperCaseRegion;
  btnText?: string;
  logisticsPackages: ScreenshotLogisticsPackage[];
  onClick?: () => void;
}

export const SendLogisticsInfo = (props: SendLogisticsInfoProps) => {
  const { platform, region, btnText, logisticsPackages, onClick } = props;
  const [visible, { toggle: toggleVisible }] = useToggle();
  const { t } = useTranslate();

  return (
    <>
      {visible && (
        <ScreenshotModal
          platform={platform}
          region={region}
          visible={visible}
          onClose={toggleVisible}
          packages={logisticsPackages}
        />
      )}
      <Button
        type="link"
        size="small"
        onClick={() => {
          toggleVisible();
          onClick?.();
        }}
      >
        {btnText || t('scene.chatWorkspace.orderTab.logistics.action.sendLogisticsDetails')}
      </Button>
    </>
  );
};
